import { DESTINATION_FOCUS_RING } from '@/components/destination-editor/focus-ring';

/**
 * Epic #228 P6 (UI/UX P2-2): keyboard focus of the crop controls (frame,
 * zoom, tabs, Reset/Cancel/Apply) is the same Za'atar olive outline the
 * destination controls of this dialog use (P5 UI/UX P2-1): about 6:1 on
 * white, offset from the control, never mistaken for the lime "selected"
 * fill. It replaces the faint lime focus ring of the Admin buttons
 * (`ring-0`). The frame clips its picture, not its own outline.
 */
export const FRAMING_FOCUS_RING = `${DESTINATION_FOCUS_RING} focus-visible:ring-0`;
